import { useCallback } from "react";
import { useSaveProductPriceHistoryMutation } from "../mutations/useSaveProductPriceHistory.mutation";
import { TProductPriceHistoryForm } from "../types/productPriceHistory.types";

export const useSaveProductPriceHistory = () => {
  const saveMutation = useSaveProductPriceHistoryMutation();

  const handleSave = useCallback(
    (values: TProductPriceHistoryForm) => {
      saveMutation.mutate(values);
    },
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
